export type PhishingTemplate = {
    id: string;
    name: string;
    department: string;
    subject: string;
    body: string;
};

export const PHISHING_TEMPLATES: PhishingTemplate[] = [
    {
        id: 'ai-generated',
        name: 'AI Generated',
        department: 'AI',
        subject: '',
        body: '',
    },
    {
        id: 'hr-policy-update',
        name: 'HR Policy Update',
        department: 'HR',
        subject: 'Updated HR policy acknowledgment needed',
        body:
            'Hi {{firstName}},\n\nWe’ve updated our HR policy and need your acknowledgment. Please review the update below:\n\n{{link}}\n\nIf this looks suspicious, report it here:\n{{reportLink}}\n\nThanks,\n{{department}}',
    },
    {
        id: 'finance-payroll-change',
        name: 'Payroll Change Notice',
        department: 'Finance',
        subject: 'Action required: Payroll update',
        body:
            'Hello {{firstName}},\n\nYour payroll settings require verification. Please review the changes below:\n\n{{link}}\n\nIf this looks suspicious, report it here:\n{{reportLink}}\n\nThanks,\nFinance Team',
    },
    {
        id: 'it-security-reset',
        name: 'Password Reset Notification',
        department: 'IT',
        subject: 'Password reset required',
        body:
            'Hi {{firstName}},\n\nWe detected unusual activity and require a password reset to keep your account secure. Reset your password below:\n\n{{link}}\n\nIf this looks suspicious, report it here:\n{{reportLink}}\n\nIT Support',
    },
    {
        id: 'operations-benefits',
        name: 'Benefits Enrollment Reminder',
        department: 'Operations',
        subject: 'Benefits enrollment reminder',
        body:
            'Hi {{firstName}},\n\nThis is a reminder to complete benefits enrollment. Please review the details below:\n\n{{link}}\n\nIf this looks suspicious, report it here:\n{{reportLink}}\n\nOperations Team',
    },
    {
        id: 'legal-policy',
        name: 'Policy Attestation Request',
        department: 'Legal',
        subject: 'Policy attestation required',
        body:
            'Hello {{firstName}},\n\nPlease attest to the latest policy update below:\n\n{{link}}\n\nIf this looks suspicious, report it here:\n{{reportLink}}\n\nThank you,\nLegal',
    },
];

export const PHISHING_TEMPLATE_TOKENS = [
    '{{firstName}}',
    '{{lastName}}',
    '{{email}}',
    '{{department}}',
    '{{organization}}',
    '{{title}}',
    '{{campaignName}}',
    '{{link}}',
    '{{reportLink}}',
];

export const PHISHING_SAMPLE_CONTEXT = {
    firstName: 'Taylor',
    lastName: 'Jordan',
    email: 'taylor.jordan@example.com',
    department: 'Engineering',
    organization: 'Amplifier',
    title: 'Senior Analyst',
    campaignName: 'Q1 Security Check',
    link: 'Click here',
    reportLink: 'Report this email',
};
